package llinsoft.site.data

object ProjectDataSource {
    val repository: ProjectRepository = JsonProjectRepository()
}
